import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Modal,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import DeleteOutlineRounded from '@material-ui/icons/DeleteOutlineRounded';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import { useDispatch } from 'react-redux';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { deleteTrainingCertificateAsync } from './CertificationStore/CertificationStoreSlice';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

// onDeleteSuccess: refetch callback after delete
// onEdit: opens the edit modal for the given row
export const certificationColumn = (
  onDeleteSuccess,
  onEdit,
  businessVertical = 'atheneum'
) => {
  const column = [
    { Header: 'Reg. Number', accessor: 'studentRegistrationNum' },
    { Header: 'Student Name', accessor: 'studentName' },
  ];
  // Show Training Centre only if not athenum
  if (businessVertical !== 'atheneum') {
    column.push({
      Header: 'Training Centre',
      accessor: 'trainingCentre',
    });
  }

  column.push(
    {
      Header: 'Award Date',
      accessor: 'awardDate',
      Cell: (val) => {
        const payload = val.cell.row.original;
        return <Box>{formatDate(payload.awardDate)}</Box>;
      },
    },
    { Header: 'Classification', accessor: 'awardClassification' },
    { Header: 'Course Type', accessor: 'courseType' },
    {
      Header: 'Vertical',
      accessor: 'businessVertical',
      Cell: (val) => {
        const payload = val.cell.row.original;
        return (
          <Box style={{ textTransform: 'capitalize' }}>
            {payload.businessVertical}
          </Box>
        );
      },
    },
    {
      Header: 'Action',
      accessor: '',
      Cell: (val) => {
        const ITEM_HEIGHT = 48;
        const dispatch = useDispatch();
        const payload = val.cell.row.original;
        const { handleLoader } = useLoader();
        const { SuccessToast } = useToast();

        const [openConfirmModal, setOpenConfirmModal] = React.useState(false);
        const [anchorEl, setAnchorEl] = React.useState(null);

        const open = Boolean(anchorEl);

        const handleClick = (event) => {
          setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
          setAnchorEl(null);
        };

        const handleOpenModal = () => {
          setOpenConfirmModal(true);
        };
        const handleCloseModal = () => {
          setOpenConfirmModal(false);
        };

        const deleteCertificate = async (row) => {
          try {
            handleLoader(true);
            dispatch(deleteTrainingCertificateAsync(row._id))
              .unwrap()
              .then((res) => {
                handleLoader(false);
                if (res) {
                  SuccessToast('Certificate was deleted successfully.');
                  handleCloseModal();
                  if (onDeleteSuccess) onDeleteSuccess();
                }
              })
              .catch(() => {
                handleLoader(false);
              });
          } catch (error) {
            handleLoader(false);
            console.log(error);
          }
        };

        const style = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          fontFamily: 'Rubik',
          borderRadius: '6px',
        };

        return (
          <Box display="flex">
            <Box width={80} fontSize={14}>
              <IconButton onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: '20ch',
                  },
                }}>
                <MenuItem onClick={() => onEdit && onEdit(payload)}>
                  Edit
                </MenuItem>
                <MenuItem onClick={handleOpenModal}>Delete</MenuItem>
              </Menu>
            </Box>
            <Modal open={openConfirmModal} onClose={handleCloseModal}>
              <Box sx={style}>
                <Box mb={5} sx={{ fontSize: 20, fontWeight: 'medium' }}>
                  Are you sure you want to delete this certificate?
                </Box>
                <Box sx={{ position: 'absolute', top: 5, right: 5 }}>
                  <IconButton onClick={handleCloseModal}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box display={'flex'} justifyContent="flex-end">
                  <Box display={'flex'}>
                    <Box mr={1}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleCloseModal}>
                        No
                      </Button>
                    </Box>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => deleteCertificate(payload)}>
                      Yes
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Modal>
          </Box>
        );
      },
    }
  );

  return column;
};
